var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 524.78 486.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:none;stroke:#333;stroke-linecap:round;stroke-linejoin:round;stroke-width:20px;}.cls-3{fill:#ed1e79;}.cls-3,.cls-4{mix-blend-mode:multiply;}.cls-4{fill:#ffad00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Banner"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphic_Elements",
    "data-name": "Graphic Elements"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "153.06 313.29 122.61 334.86 122.61 377.9 479.26 377.9"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 187.05,
    cy: 439.8,
    r: 33.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 409.43,
    cy: 439.8,
    r: 33.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "104.28 131.82 85.66 62.21 10 14.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "493.29 131.82 444.52 314.17 443.58 314.17 153.06 314.17 104.28 131.82 493.29 131.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M433.78,31.42,220.17.11a10,10,0,0,0-11.34,8.44L176,232.64A10,10,0,0,0,184.42,244L398,275.3a10,10,0,0,0,11.35-8.44l32.85-224.1A10,10,0,0,0,433.78,31.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164,164.73H514.78a10,10,0,0,1,9.57,12.9l-44.2,164.74a10,10,0,0,1-9.57,7.11h-273a10,10,0,0,1-9.75-7.76L154.25,177A10,10,0,0,1,164,164.73Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 220.1,
    cy: 445.42,
    r: 41.47,
    transform: "translate(-250.49 286.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 444.52,
    cy: 445.42,
    r: 41.47,
    transform: "translate(-136.62 204.01) rotate(-22.5)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.15d0ec5610e59f623a8c51e19affd3b9.svg";
export { ForwardRef as ReactComponent };